var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM6.45534 8.70507L10.3123 4.84812C10.5786 4.58185 11.0103 4.58189 11.2766 4.84816C11.5428 5.11444 11.5428 5.54612 11.2766 5.81239L6.93743 10.1514C6.80957 10.2793 6.63616 10.3511 6.45534 10.3511H6.4553C6.27448 10.3511 6.10107 10.2793 5.97321 10.1514L3.72339 7.90148C3.45711 7.63521 3.45711 7.20353 3.72339 6.93726C3.98966 6.67103 4.42139 6.67107 4.68761 6.9373L6.45534 8.70507Z",
    fill: "#6FCF97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.47de2a19bfd1c5a32870a1ef7ca43a0d.svg";
export { ForwardRef as ReactComponent };